import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function DetailCardItemWrapper({ children }: Props) {
  return <div className="flex flex-col gap-[16px]">{children}</div>;
}
